import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RESOLVE_SHORT_URL } from '../lib/urls';
import Spinner from '../lib/ui/components/spinner/Spinner';
import { SmallText, Heading5 } from '../lib/ui/components/typography/Typography';
import InterviewPage from '../pages/interviewPage';

const ShortUrlRedirect = () => {
    const { shortId } = useParams();
    const [resolvedData, setResolvedData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const resolveShortUrl = async () => {
            try {
                const response = await fetch(RESOLVE_SHORT_URL(shortId));

                if (response.ok) {
                    const data = await response.json();
                    if (data.redirect_url) {
                        // Extract job_id and company_id from the redirect URL
                        const url = new URL(data.redirect_url, window.location.origin);
                        const pathParts = url.pathname.split('/');
                        const jobId = pathParts[pathParts.length - 2]; // /interview/{jobId}/invite
                        const companyId = url.searchParams.get('companyId');

                        // Set the resolved data for InterviewPage
                        setResolvedData({
                            job_id: jobId,
                            company_id: companyId,
                            role_name: data.role_name,
                            company_name: data.company_name,
                            short_id: shortId
                        });
                    } else {
                        throw new Error('Invalid response from server');
                    }
                } else if (response.status === 404) {
                    setResolvedData(null);
                    setIsLoading(false);
                    return;
                } else {
                    throw new Error('Error loading interview link');
                }
            } catch (error) {
                console.error('Error resolving short URL:', error);
                setResolvedData(null);
                setIsLoading(false);
                throw error;
            } finally {
                setIsLoading(false);
            }
        };

        if (shortId) {
            resolveShortUrl();
        }
    }, [shortId]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-center">
                    <Spinner size="lg" className="mb-4" />
                </div>
            </div>
        );
    }

    if (resolvedData) {
        return <InterviewPage resolvedData={resolvedData} />;
    }

    // Error state 
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="text-center">
                <Heading5 className="mb-4">
                    Interview Not Found
                </Heading5>
                <SmallText className="mb-6">
                    The interview you're looking for doesn't exist or may have been removed. Please contact your recruiter for more information.
                </SmallText>
            </div>
        </div>
    );
};

export default ShortUrlRedirect;
